import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {useHistory} from "react-router-dom";
import React from "react";
import BarcodeReader from 'react-barcode-reader';

export function FSBarcodeReader(props) {

    const history = useHistory()

    const handleScan = (result) => {
      console.log('handleScan ' + result)

      // setResult(result)
      props.onRequestStart()


      axios.get(`${process.env.REACT_APP_API_HOST}/product?barcode=${result}&token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
        .then((resp)=>{

          // console.log(history);
          if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
            props.onRequestResults(resp.data['results'], result)
          }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
            history.replace('/signin')
          }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
            cookie.remove(RECEIVER_COOKIE_KEY)
            history.replace('/not-permitted')
          }else{

            if(resp.data != null){
              props.onRequestError("오류코드 : " + resp.data['code'])
            }else{
              props.onRequestError("오류코드 : " + resp.status,)
            }
          }
        }).catch((e)=>{
          console.log('error : ' + e);
          if(e.response != null && e.response.status > 0){
            props.onRequestError("오류코드 : " + e.response.status)
          }else{
            props.onRequestError("네트워크 환경을 확인 해 주세요")
          }
        });
    }

  const handleError = (error) => {
    console.log('handleError ' + error)
  }

  return <BarcodeReader
    onError={handleError}
    onScan={handleScan}
  />


}